import Vue from 'vue'
import Vuex from 'vuex'

import actions from './actions'
import analytics from './analytics'
import auth from './auth'
import autoschedule from './autoschedule'
import bookings from './bookings'
import bookingSources from './booking_sources'
import calendar from './calendar'
import candidates from './candidates'
import chat from './chat'
import cities from './cities'
import clientsSegments from './clientsSegments'
import companies from './companies'
import contractors from './contractors'
import countries from './countries'
import customers from './customers'
import district from './district'
import educations from './educations'
import employer_windows from './employer_windows'
import employerCategories from './employer_categories'
import employerPriceCategory from './employer_price_category'
import employers from './employers'
import employerSettings from './employer_settings'
import feedbacks from './feedbacks'
import feedbackStatuses from './feedback_statuses'
import filtersData from './filters_data'
import finances from './finances'
import fingerPrints from './finger_prints'
import getters from './getters'
import goodBrands from './good_brands'
import goodFlows from './good_flows'
import goodGives from './good_gives'
import goodGroups from './good_groups'
import goodInvents from './good_invents'
import goodInvoices from './good_invoices'
import goodLines from './good_lines'
import goodOrders from './good_orders'
import goodRemains from './good_remains'
import goods from './goods'
import goodTypes from './good_types'
import equipmentTypes from './equipment_types'
import equipmentPlaces from './equipment_places'
import KKM from './KKM'
import logs from './logs'
import metros from './metro'
import mutations from './mutations'
import notifications from './notifications'
import notify from './notify'
import permissions from './permissions'
import plChat from './plChat'
import questionTickets from './questionTickets'
import regions from './regions'
import reviews from './reviews'
import schedule from './schedule/index'
import searchServiceCategories from './search_service_categories'
import serviceCategories from './service_categories'
import services from './services'
import serviceTemplates from './service_templates'
import settingsAccount from './settings_account'
import settingsCompany from './settings_company'
import settingsSystem from './settings_system'
import settlementSheet from './settlementSheet'
import smsHistory from './sms_history'
import store from './store'
import telephony from './telephony'
import tickets from './tickets'
import unitRevenuePlans from './unit_revenue_plans'
import units from './units'
import user_source from './user_sources'
import users from './users'
import vouchers from './vouchers'
import windows from './windows'
import workPlaces from './work_places'
import workplaces from './workplaces'
import workPositions from './work_positions'
import nailDesigns from './nailDesigns'

import VueResource from 'vue-resource'

Vue.use(VueResource)

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    auth,
    autoschedule,
    analytics,
    calendar,
    clientsSegments,
    employers,
    feedbacks,
    feedbackStatuses,
    fingerPrints,
    reviews,
    permissions,
    services,
    serviceCategories,
    logs,
    workPositions,
    employerCategories,
    employerPriceCategory,
    employerSettings,
    regions,
    countries,
    educations,
    schedule,
    cities,
    candidates,
    metros,
    district,
    workPlaces,
    units,
    unitRevenuePlans,
    companies,
    windows,
    bookings,
    bookingSources,
    workplaces,
    customers,
    contractors,
    chat,
    plChat,
    users,
    user_source,
    employer_windows,
    searchServiceCategories,
    telephony,
    goods,
    goodBrands,
    goodLines,
    goodTypes,
    goodGroups,
    goodFlows,
    goodRemains,
    goodGives,
    goodInvoices,
    goodInvents,
    goodOrders,
    equipmentTypes,
    equipmentPlaces,
    settingsCompany,
    settingsSystem,
    settingsAccount,
    finances,
    KKM,
    smsHistory,
    notifications,
    serviceTemplates,
    store,
    tickets,
    questionTickets,
    settlementSheet,
    notify,
    filtersData,
    vouchers,
    nailDesigns,
  },
  user: null,
  strict: debug,
  state: {
    load: false,
    overlay: false,
    title: '',
    user: null,
    selfPermissions: [],
    userStatus: 1,
    userAvatar: null,
    menu: null,
    sessionMenu: null,
    showPreloader: true,
    selectedDate: null,
    openedSettings: false,
    timezone: 'Europe/Moscow',
  },
  getters,
  mutations,
  actions,
})
